module.exports = __webpack_public_path__ + "media/common/statics/misaki-091a3fe0c76f16b8f28f9dda790eacd7.png";